"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Styles = require("../utils/Styles");

var _UIIcon = _interopRequireDefault(require("./UIIcon"));

var _IconConstants = require("./IconConstants");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 1em;\n  width: 1em;\n  margin: 0.25em 0.125em 0;\n  transform-origin: 50% 38%;\n  transform: ", " translateY(-6.3%);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-flex;\n  line-height: 1;\n  user-select: none;\n  position: relative;\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-style: ", ";\n  border-width: ", ";\n  font-size: ", ";\n  padding: ", ";\n  transform: ", ";\n  vertical-align: ", ";\n\n  &.private-icon-circle--legacy {\n    display: inline-flex;\n    align-items: center;\n    height: 2em;\n    justify-content: center;\n    width: 2em;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Outer = _styledComponents.default.span.withConfig({
  displayName: "UIIconHolder__Outer",
  componentId: "sc-1uldnpi-0"
})(_templateObject(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var borderColor = _ref2.borderColor;
  return borderColor;
}, function (_ref3) {
  var borderRadius = _ref3.borderRadius;
  return borderRadius;
}, function (_ref4) {
  var borderStyle = _ref4.borderStyle;
  return borderStyle;
}, function (_ref5) {
  var borderWidth = _ref5.borderWidth;
  return (0, _Styles.toPx)(borderWidth);
}, function (_ref6) {
  var size = _ref6.size;
  return size != null && (_IconConstants.ICON_SIZES[size] || size) + "px";
}, function (_ref7) {
  var padding = _ref7.padding;
  return padding != null && padding + "em";
}, function (_ref8) {
  var rotate = _ref8.rotate;
  return rotate != null && "rotate(" + rotate + "deg)";
}, function (_ref9) {
  var verticalAlign = _ref9.verticalAlign;
  return verticalAlign;
});

var getIconTransform = function getIconTransform(_ref10) {
  var rotate = _ref10.rotate,
      rotateLock = _ref10.rotateLock;
  return rotate != null && !rotateLock ? "rotate(" + rotate * -1 + "deg)" : null;
};

var Icon = (0, _styledComponents.default)(function (props) {
  var __rotate = props.rotate,
      __rotateLock = props.rotateLock,
      rest = (0, _objectWithoutProperties2.default)(props, ["rotate", "rotateLock"]);
  return _react.default.createElement(_UIIcon.default, rest);
}).withConfig({
  displayName: "UIIconHolder__Icon",
  componentId: "sc-1uldnpi-1"
})(_templateObject2(), getIconTransform);

var UIIconHolder =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIIconHolder, _PureComponent);

  function UIIconHolder() {
    (0, _classCallCheck2.default)(this, UIIconHolder);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIIconHolder).apply(this, arguments));
  }

  (0, _createClass2.default)(UIIconHolder, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _fromUIIconCircle = _this$props._fromUIIconCircle,
          borderRadius = _this$props.borderRadius,
          color = _this$props.color,
          innerClassName = _this$props.innerClassName,
          innerStyles = _this$props.innerStyles,
          name = _this$props.name,
          rotate = _this$props.rotate,
          rotateLock = _this$props.rotateLock,
          size = _this$props.size,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["_fromUIIconCircle", "borderRadius", "color", "innerClassName", "innerStyles", "name", "rotate", "rotateLock", "size"]);

      if (borderRadius === '50%' && !_fromUIIconCircle) {
        _devLogger.default.warn({
          message: 'UIIconHolder: Instead of using borderRadius="50%", use a UIIconCircle.',
          key: "UIIconHolder-circle"
        });
      }

      return _react.default.createElement(Outer, (0, _extends2.default)({}, rest, {
        borderRadius: borderRadius,
        rotate: rotate,
        size: size
      }), _react.default.createElement(Icon, {
        className: innerClassName,
        color: color,
        name: name,
        rotate: rotate,
        rotateLock: rotateLock,
        size: size,
        style: innerStyles
      }));
    }
  }]);
  return UIIconHolder;
}(_react.PureComponent);

exports.default = UIIconHolder;
UIIconHolder.propTypes = {
  _fromUIIconCircle: _react.PropTypes.bool,
  backgroundColor: _react.PropTypes.string,
  borderColor: _react.PropTypes.string,
  borderRadius: _react.PropTypes.string,
  borderStyle: _react.PropTypes.oneOf(['solid', 'double', 'dashed', 'dotted', 'initial', 'inherit', 'unset']),
  borderWidth: _react.PropTypes.number,
  verticalAlign: _react.PropTypes.string,
  classname: _react.PropTypes.string,
  color: _UIIcon.default.propTypes.color,
  innerClassName: _react.PropTypes.string,
  name: _UIIcon.default.propTypes.name,
  padding: _react.PropTypes.number,
  rotate: _react.PropTypes.number,
  rotateLock: _react.PropTypes.bool,
  size: _UIIcon.default.propTypes.size,
  innerStyles: _react.PropTypes.object
};
UIIconHolder.defaultProps = {
  padding: 0.5,
  rotate: 0,
  borderStyle: 'solid',
  borderWidth: 0
};
UIIconHolder.displayName = 'UIIconHolder';
module.exports = exports.default;